import React, {useState} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Col, Container, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import {saveData} from "../../../helpers/Api";
import {createPlateMutation, getPlateById, getPlates, updatePlateMutation} from "./PlateQueries";
import PlateIngredientsList from "./PlateIngredientsList";
import UploadFile from "../../shared/UploadFile";
import {BackButton} from "../../../helpers/ButtonHelper";
import PageTitle from "../../../layout/PageTitle";

const PlateForm = () => {
  const params = useParams();
  const navigate = useNavigate()
  const [flash, setFlash] = useState({});
  const [plate, setPlate] = useState({
    id: '',
    name: '',
    description: '',
    image: '',
    ingredients: []
  })
  const { loading, data, refetch } = useQuery(getPlateById, { variables: { id: params.id }, fetchPolicy: "no-cache" })

  let mutation = createPlateMutation;
  let response_key = 'createPlate'

  if (params.id) {
    mutation = updatePlateMutation
    response_key = 'updatePlate'

    if (!plate.id && !loading && data)
      setPlate(data.plate)
  }

  const [saveCall] = useMutation(mutation, { refetchQueries: [getPlates] })

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: response_key,
      flash_callback: setFlash,
      success: (res) => {
        if (!params.id)
          navigate(`/plates/${res.plate.id}`)
      }
    })
  }

  return (
    <>
      <Container className='mb-4'>
        <PageTitle title={params.id ? 'Modifica reteta' : 'Adauga reteta'} />
        <Row className='d-sm-flex mb-4 mt-4 align-items-start'>
          <Col className='flex-shrink-0 me-2 col-auto p-2'>
            {plate.id &&
              <UploadFile model='plate' id={plate.id} field='image'
                          filePath={plate.image} onChange={refetch} />}
          </Col>
          <Col>
            <form onSubmit={onSubmit}>
              <input type='hidden' name='id' id="id" defaultValue={plate.id} />

              <Row className="mb-2">
                <Col>
                  <label htmlFor="name">Denumire</label>
                  <input type='text' name='name' className="form-control" id="name" defaultValue={plate.name} />
                </Col>
              </Row>
              {/*<Row className="mb-2">*/}
              {/*  <Col>*/}
              {/*    <label htmlFor="category_id">Perioada zilei</label>*/}
              {/*    {!loading &&*/}
              {/*      <Select name='categoryId' id="category_id" className="basic-single"*/}
              {/*              options={categories && dataForSelect(categories)}*/}
              {/*              defaultValue={plate.category.id && selectValue(plate.category)}/>*/}
              {/*    }*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              <Row className='mb-2'>
                <Col>
                  <label htmlFor="details">Descriere</label>
                  <textarea name='details' className="form-control" id="details" defaultValue={plate.details} />
                </Col>
              </Row>

              <Row className="mb-3">
                <FlashMessage flash={flash} buttons={
                  <>
                    <BackButton className='float-end' showText={true} size='md' />
                    <Button type='submit' className='float-end'>Salveaza</Button>
                  </>
                } />
              </Row>
            </form>
          </Col>
        </Row>

        {plate && plate.id &&
          <PlateIngredientsList plate={plate}></PlateIngredientsList>
        }
      </Container>
    </>
  )
};

export default PlateForm;
